module.exports = __webpack_public_path__ + "img/idcardz.c3ecf140.png";